export default __webpack_public_path__ + "static/Thank_you_pop_up-1549835452ac35ead1f8fd1e9b7dc8cc.jpg";